module.exports = __webpack_public_path__ + "media/images/landing__leaguesTeaser-e66def0c5f15ebc71eddd890b2c0f3d0.jpg";